import styled from 'styled-components';
import {Badge} from 'react-bootstrap';


const StyledBadge = styled(Badge)`
    && {
		border-radius: 2px;
  		padding: 4px 7px;
		background-color: ${props => props.theme.brandColorLighten};
		color: ${props => props.theme.brandContrast};
	}
            
`;

export default StyledBadge;


// WEBPACK FOOTER //
// ./components/utils/Styled/badge.js